const areas = [
  'Johnston', 'Des Moines', 'Ankeny', 'Urbandale',
  'Clive', 'West Des Moines', 'Grimes', 'Waukee',
  'Adel', 'Altoona',
];

export default function ServiceAreas() {
  return (
    <section className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          {/* Text */}
          <div>
            <p
              className="text-[#B8956A] text-[11px] font-bold uppercase tracking-[0.22em] mb-5"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Where We Work
            </p>
            <h2
              className="text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-4 leading-tight"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Serving Local<br />Homeowners
            </h2>
            <div className="w-14 h-px bg-[#B8956A] mb-8"></div>
            <p
              className="text-[#555] text-lg leading-relaxed mb-10"
              style={{ fontFamily: 'Lora, serif' }}
            >
              Culp Home Improvement serves homeowners across the greater Des Moines metro area, delivering reliable craftsmanship and professional home improvement services throughout the region.
            </p>

            {/* Area tags */}
            <div className="flex flex-wrap gap-2.5 mb-12">
              {areas.map((area, i) => (
                <span
                  key={i}
                  className="flex items-center gap-1.5 bg-[#F5F2EE] text-[#2B2B2B] text-sm font-medium px-4 py-2 rounded-full border border-[#E8E0D8]"
                  style={{ fontFamily: 'Montserrat, sans-serif' }}
                >
                  <i className="ri-map-pin-2-fill text-[#B8956A] text-xs"></i>
                  {area}, IA
                </span>
              ))}
            </div>

            {/* Stats row */}
            <div className="grid grid-cols-3 gap-4">
              {[
                { icon: 'ri-home-4-fill', label: 'Residential\nProjects' },
                { icon: 'ri-map-2-fill', label: 'Neighborhood\nExpertise' },
                { icon: 'ri-user-star-fill', label: 'Consistent\nLocal Presence' },
              ].map((item, i) => (
                <div key={i} className="text-center p-5 bg-[#FAFAF8] border border-[#E8E0D8]">
                  <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                    <i className={`${item.icon} text-[#B8956A] text-2xl`}></i>
                  </div>
                  <p
                    className="text-[#2B2B2B] text-xs font-semibold leading-snug whitespace-pre-line"
                    style={{ fontFamily: 'Montserrat, sans-serif' }}
                  >
                    {item.label}
                  </p>
                </div>
              ))}
            </div>
          </div>

          {/* Map — real Google Maps embed for Johnston, IA */}
          <div className="w-full h-[500px] overflow-hidden border border-[#E8E0D8]">
            <iframe
              title="Culp Home Improvement - Johnston, IA"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d47882.12345678!2d-93.71770!3d41.67280!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x87ee9a5b5b5b5b5b%3A0x0!2sJohnston%2C+IA+50131!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
